export { default } from "./VerificationSentConfirmation";
